export default "__VITE_ASSET__9b223cd8__"